import React, { useState } from "react";
import styled from "styled-components";
import RightArrow from "../images/menu-right.svg";

const Outerwraper = styled.div`
  width: 700px;
  height: 511px;
  border-radius: 5px;
  background-image: url(${(props) => props.dImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  @media screen and (max-width: 767px) {
    width: 71vw;
    height: 300px;
  }
`;
const Heading = styled.p`
  margin: 0;
  color: #000;
  /* font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.2px; */
  font-family: Roboto;
  font-size: 37px;
  font-weight: 400;
  line-height: 52.54px;
  text-align: center;
  width: 830px;
  margin-top: -16px;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 35px;
    font-weight: 400;
    line-height: 51px;
    text-align: center;
    width: 300px;
    /* margin-left: -35px; */
    margin-top: -38px;
  }
`;
const Outerbox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  gap: 30px;
  padding: 130px 100px;
  padding-bottom: 150px;
  background: ${(props) => (props.temporaryhideImage ? "#FFF2E3" : "")};
  height: ${(props) => (props.temporaryhideImage ? "auto" : "")};
  /* height: 462px; */

  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    margin-top: 0px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    /* height: 630px; */
    height: 100%;
        padding: 100px 0;
  }
`;
const Leftbox = styled.div`
margin-top: 10px;
`;
const LeftContent = styled.span`
  margin: 0;
  color: #000000;
  /* font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; */
  /* text-align: left; */
  width: 890px;
  margin-top: 13px;
  margin-bottom: 10px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 300;
  line-height: 38px;
  letter-spacing: 0.05em;
  text-align: center;

  @media screen and (max-width: 767px) {
    width: 338px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 20px;
    font-weight: 300;
    line-height: 34px;
  }
`;
const LeftContent1 = styled.span`
  margin: 0;
  color: #000000;
  /* font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; */
  /* text-align: left; */
  width: 890px;
  margin-top: 13px;
  margin-bottom: 10px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  line-height: 38px;
  letter-spacing: 0.05em;
  text-align: center;

  @media screen and (max-width: 767px) {
    width: 338px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 20px;
    font-weight: 300;
    line-height: 34px;
  }
`;
const Link = styled.a`
  color: #4b59dd;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  :hover {
    color: #15436d;
  }
`;
const Img = styled.img``;

const Headingwraper = styled.div`
  display: ${(props) => (props.temporaryhideImage ? "flex" : "")};
  align-items: ${(props) => (props.temporaryhideImage ? "center" : "")};
  flex-direction: ${(props) => (props.temporaryhideImage ? "column" : "")};
  @media screen and (max-width: 767px) {
    padding: 0 15px;
    /* margin-left: ${(props) => (props.temporaryhideImage ? "41px" : "")}; */
    margin-left: ${(props) => (props.temporaryhideImage ? "0px" : "")};
  }
`;

export default function MapImageText(props) {
  const HandleLink = () => {
    if (props.Title == "Market Analysis") {
      window.location.href = "/ResearchGoal/Market-Analysis.html";
    }
    if (props.Title == "Technology Analysis") {
      window.location.href = "/ResearchGoal/Technology-Analysis.html";
    }
    if (props.Title == "New Business Creation") {
      window.location.href =
        "/ResearchGoal/New-Business-Creation.html";
    }
    if (props.Title == "New Product Development") {
      window.location.href =
        "/ResearchGoal/New-Product-Development.html";
    }
    if (props.Title == "Application Use Case Analysis") {
      window.location.href =
        "/ResearchGoal/Use-Case-Analysis.html";
    }
  };
  const [temporaryhideImage, setTemporaryhideImage] = useState(true);

  return (
    <div>
      <Outerbox temporaryhideImage={temporaryhideImage}>
        {!temporaryhideImage && (
          <div>
            <Outerwraper alt={props.Title} dImage={props.dImage}></Outerwraper>
          </div>
        )}
        <Headingwraper temporaryhideImage={temporaryhideImage}>
          {props.text == "jugaaad" ? (
            <>
              <Heading>{props.Title}</Heading>
              <br></br>
              <LeftContent1>{props.Content21}</LeftContent1>
              <LeftContent>{props.Content2}</LeftContent>
            </>
          ) : (
            <>
              <LeftContent>{props.Content2}</LeftContent>
              <br></br>
              <Heading>{props.Title}</Heading>
            </>
          )}

          <Leftbox>
            <LeftContent1>{props.Content21}</LeftContent1>
            <LeftContent>{props.Content}</LeftContent>
            <LeftContent style={{ marginTop: "10px" }}>
              {props.Content1}
            </LeftContent>
            {props.link && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Link onClick={HandleLink}>{props.link}</Link>
                <Img src={RightArrow} style={{ cursor: "pointer" }}></Img>
              </div>
            )}
          </Leftbox>
        </Headingwraper>
      </Outerbox>
    </div>
  );
}
